module.exports = __webpack_public_path__ + "img/shuixi12.d21fe3bd.png";